import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { initialize } from 'configs/initialize';
import Root from 'pages/Root';

import 'styles/globalStyles.scss';

const startApp = () => {
  initialize();

  createRoot(document.getElementById('root') as HTMLElement).render(<Root />);
};

startApp();
